import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Box } from "@mui/material";
import MobileBottomNav from "./MobileBottomNav";
import MobileTopBar from "./MobileTopBar";

const Layout = () => {
  return (
    <Box sx={{ display: "flex", height: "100dvh", overflow: "hidden" }}>
      <Box sx={{ display: "none", "@media (min-width:1024px)": { display: "block" } }}>
        <Sidebar />
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: "hidden",
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          pt: "56px",
          "@media (min-width:1024px)": {
            pt: 0,
          },
        }}
      >
        <Outlet />
      </Box>
      <MobileTopBar />
      <MobileBottomNav />
    </Box>
  );
};

export default Layout;
